import { BsCheckLg } from 'react-icons/bs'
import parse from 'html-react-parser';

import { cme_kurs } from '../Global/Kurs'
import KursButton from '../KursButton';

import welcomeImage from '../../img/login_welcome.png'



const WelcomeScreen = ({ jumpToStep, rawAnswers }) => {


    return (
        <div id="loginHandler-welcome">
            <h2>Ausgezeichnet! Sie haben diesen Kurs vollständig bearbeitet.</h2>

            <div>
                <KursButton
                    buttonName="Weiter zum Login"
                    backgroundColor="green"
                    btnIcon={<BsCheckLg />}
                    // jump to step 1 if it is a gcp-course
                    onClick={() => {
                        if (cme_kurs.isGcp) { jumpToStep(1) } else { jumpToStep(3) }
                    }}
                />
            </div>

            <br />
            <h5>Überprüfen Sie Ihre Antworten:</h5>
            <div className="confirmation-container">

                {(rawAnswers) ?
                    <>
                        {rawAnswers.map((answerIndex, questionIndex) => {
                            const question = cme_kurs.Wissensfragen[questionIndex];
                            const answer = question.answers[answerIndex];

                            return (
                                <div key={questionIndex} className="confirmation">
                                    <p className="confirmation-question">{question.questionNr + ": "}{parse(question.question)}</p>
                                    {(answer !== undefined && answer !== null) ?
                                        <>
                                            <p><strong>{answer.name}:</strong> {parse(answer.answertext)}</p>
                                        </> : <></>}
                                    <hr />
                                </div>
                            )
                        }
                        )}
                    </>
                    :
                    "nicht definiert"
                }

            </div>

            <div className="welcome-image-container">
                <img className="welcome-image" src={welcomeImage} alt="" />
            </div>
        </div>
    )
}

export default WelcomeScreen